import { FC, PropsWithChildren } from 'react';
import { css, Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';
import { StatsFooter } from './stats-footer';
import { StatsHeader } from './stats-header';
import { StatsList } from './stats-list';

interface SchedulingStatsCardNamespace
  extends FC<PropsWithChildren<{ styles?: Interpolation<Theme>; dataTestId?: string }>> {
  Header: typeof StatsHeader;
  Footer: typeof StatsFooter;
  List: typeof StatsList;
}

export const SchedulingStatsCard: SchedulingStatsCardNamespace = ({ children, styles, dataTestId }) => {
  return (
    <div css={[defaultStyles.container, styles]} data-testid={dataTestId}>
      {children}
    </div>
  );
};

SchedulingStatsCard.Header = StatsHeader;
SchedulingStatsCard.Footer = StatsFooter;
SchedulingStatsCard.List = StatsList;

const defaultStyles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(3)};
    padding: ${theme.spacing(3)};
    border: 1px solid ${theme.colors.neutral20};
    border-radius: ${theme.borderRadius.medium};
    container-type: inline-size;
  `,
};
